// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".aspect-thumbnail[data-v-7d9f28f0]{padding-top:68.13187%}.aspect-thumbnail-responsive[data-v-7d9f28f0]{position:relative;display:block;padding-top:90%}.product-img-position[data-v-7d9f28f0]{bottom:-32px}@media (min-width: 768px){.aspect-thumbnail-responsive[data-v-7d9f28f0]{padding-top:68.13187%}.product-img-position[data-v-7d9f28f0]{bottom:-72px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
